import { APP_INITIALIZER, ErrorHandler, inject, LOCALE_ID, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';


import localeHu from '@angular/common/locales/hu';
import { registerLocaleData } from "@angular/common";
import {
  AppConfig,
  EclickCoreModule,
  LanguageService,
  provideErrorHandler,
  provideHeaderInterceptor,
  provideInitApi
} from "@eclick/core-v2";
import { AppInitService } from "./core/services/app-init/app-init.service";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";

registerLocaleData(localeHu);

const config: AppConfig = {
  // staging (build swap — do not commit)
  apiUrl: 'https://api.configurator.promoc.io/api/',

  // prod
  // apiUrl: 'https://konfiguratorapi.hyundai.hu/api/',

  // prod - backup
  // apiUrl: 'https://hyundaiconfiguratorbackend.promoc.io/api/',

  // local
  // apiUrl: 'http://hyundai-config-mock.test/api/',

  // staging
  // apiUrl: 'https://api.configurator.promoc.io/api/',

  dbPrefix: 'hyundai-config',
  supportedLanguages: ['hu']
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    EclickCoreModule.forRoot(config),
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'hu-HU'
    },
    provideHeaderInterceptor(),
    provideErrorHandler(),
    provideAppInitializer(() => {
      const initializerFn = (provideInitApi)(inject(AppInitService), inject(LanguageService));
      return initializerFn();
    }),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
